import "./chunk-BSSMCHER.mjs";

// src/crypto.js
var randomBytes = () => {
  throw new Error("Not available on this platform");
};
export {
  randomBytes
};
//# sourceMappingURL=crypto.mjs.map
